import { useState, useEffect, useContext } from "react";

import MessageInfo from "../components/message/MessageInfo.jsx";
import useAxios from "../services/useAxios.tsx";
import Helmet from "react-helmet";
import { searchFunc } from "../utils/helperFunction";
import SearchInputContext from "../Search/SearchInput";
import AuthenticationContext from "../Authentication/AuthenticationContext.ts";

export default function Message({ user_id }) {
  const { userInfo } = useContext(AuthenticationContext);

  const { execute: messageListApi } = useAxios(
    "api/message_list_with_sender_receiver"
  );
  const { searchInput } = useContext(SearchInputContext);
  const [content, setContent] = useState([]);
  const [searchContent, setSearchContent] = useState([]);
  // const [messageList, setMessageList] = useState([]);
  // useEffect(() => {
  //   messageListApi().then(data => {
  //     setMessageList(data.data);
  //     console.log("message", data.data);
  //   });
  // }, []);

  useEffect(() => {
    let x;
    if (user_id != undefined) {
      x = { user_id: user_id };
    }
    messageListApi(x).then((data) => {
      // setMessageList(data.data);
      // });
      // let temp = [...messageList];
      if (user_id == undefined) {
        let temp = [...data.data];
        let temp2 = [];
        for (let i = 0; i < temp.length; i++) {
          let object = {};
          object.sender = temp[i].sender[0].fullname;
          object.receiver = temp[i].reciver[0].fullname;
          object.auto = temp[i].automate;
          object.type = temp[i].type;
          object.date = temp[i].mtm;
          object.text = temp[i].text;
          object.id = temp[i].id;
          temp2.push(object);
        }

        setContent(temp2);
        setSearchContent(temp2.reverse());
      } else {
        // let temp =
      }
    });
  }, []);
  useEffect(() => {
    let temp = searchFunc(
      searchInput,
      searchContent.map((value) => {
        console.log("value", value);
        return {
          ...value,
          receiver_search: `${value?.receiver}`,
          sender_search: `${value?.sender}`,
        };
      })
    );
    setContent(temp);
  }, [searchInput]);
  return (
    <>
      <Helmet>
        <title>ارتباطات</title>
      </Helmet>
      {userInfo.userRoll.includes(35) && <MessageInfo content={content} />}
    </>
  );
}
